
import Vue, { PropType } from 'vue'
import { Checkbox } from 'vue-checkbox-radio'

export default Vue.extend({
  name: 'BaseArrayCheckbox',

  components: {
    Checkbox
  },

  props: {
    value: Array as PropType<Array<string>>,
    label: String as PropType<string>,
    iconName: String as PropType<string>,
    iconSize: Number as PropType<number>,
    checkedValue: String as PropType<string>,
  },

  computed: {
    bindValue: {
      get (): string[] {
        return this.value
      },

      set (): void {
        if (this.isChecked) {
          const filtered: string[] = this.value.filter((s: string) => {
            return s !== this.checkedValue
          })
          this.$emit('input', filtered)
          return
        }
        this.$emit('input', [...this.value, this.checkedValue])
      }
    },

    isChecked(): boolean {
      return this.value.includes(this.checkedValue)
    },

    iconContainerStyleText(): string {
      if (this.iconSize) {
        return `width: ${this.iconSize}px; height: ${this.iconSize}px;`
      }
      return ''
    }
  },
})
